// import React, { useEffect, useState, useRef, useCallback } from 'react';
// import { Routes, Route, useLocation } from 'react-router-dom';
// import Navbar from './components/Navbar';
// import Hero from './components/Hero';
// import Stats from './components/Stats';
// import About from './components/About';
// import Teams from './components/Teams';
// import Roadmap from './components/Roadmap';
// import Services from './components/Services';
// import Tools from './components/Tools';
// import FAQ from './components/FAQ';
// import Footer from './components/Footer';
// import HelixHome from './helixone/pages/Home';
// import HelixDatabases from './helixone/pages/Databases';
// import HelixTools from './helixone/pages/Tools';
// import HelixToolDetails from './helixone/pages/ToolDetails';
// import Phiverse from './phiverse/Phiverse';
// import './App.css';

// const MainPage = () => {
//   const [scrollProgress, setScrollProgress] = useState(0);

//   useEffect(() => {
//     const onScroll = () => {
//       const h = document.documentElement.scrollHeight - window.innerHeight;
//       setScrollProgress(h > 0 ? (window.scrollY / h) * 100 : 0);
//     };
//     window.addEventListener('scroll', onScroll, { passive: true });
//     return () => window.removeEventListener('scroll', onScroll);
//   }, []);

//   return (
//     <>
//       <div className="progress-bar" style={{ width: `${scrollProgress}%` }} />
//       <Hero />
//       <div className="section-divider-wave"><svg viewBox="0 0 1440 120" preserveAspectRatio="none"><path d="M0,60 C360,120 720,0 1440,60 L1440,0 L0,0 Z" fill="var(--surface)"/></svg></div>
//       <Stats />
//       <div className="section-divider-wave wave-alt"><svg viewBox="0 0 1440 120" preserveAspectRatio="none"><path d="M0,60 C360,0 720,120 1440,60 L1440,0 L0,0 Z" fill="var(--main-bg)"/></svg></div>
//       <About />
//       <div className="section-divider-wave"><svg viewBox="0 0 1440 120" preserveAspectRatio="none"><path d="M0,60 C360,120 720,0 1440,60 L1440,0 L0,0 Z" fill="var(--surface)"/></svg></div>
//       <Teams />
//       <div className="section-divider-wave wave-alt"><svg viewBox="0 0 1440 120" preserveAspectRatio="none"><path d="M0,60 C360,0 720,120 1440,60 L1440,0 L0,0 Z" fill="var(--main-bg)"/></svg></div>
//       <Roadmap />
//       <div className="section-divider-wave"><svg viewBox="0 0 1440 120" preserveAspectRatio="none"><path d="M0,60 C360,120 720,0 1440,60 L1440,0 L0,0 Z" fill="var(--surface)"/></svg></div>
//       <Services />
//       <div className="section-divider-wave wave-alt"><svg viewBox="0 0 1440 120" preserveAspectRatio="none"><path d="M0,60 C360,0 720,120 1440,60 L1440,0 L0,0 Z" fill="var(--main-bg)"/></svg></div>
//       <Tools />
//       <div className="section-divider-wave"><svg viewBox="0 0 1440 120" preserveAspectRatio="none"><path d="M0,60 C360,120 720,0 1440,60 L1440,0 L0,0 Z" fill="var(--surface)"/></svg></div>
//       <FAQ />
//     </>
//   );
// };

// const ScrollToTop = () => {
//   const { pathname } = useLocation();
//   useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
//   return null;
// };

// function App() {
//   const cursorRef = useRef(null);
//   const cursorDotRef = useRef(null);

//   useEffect(() => {
//     const onMove = (e) => {
//       if (cursorRef.current) {
//         cursorRef.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
//       }
//       if (cursorDotRef.current) {
//         cursorDotRef.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
//       }
//     };
//     document.addEventListener('mousemove', onMove);
//     return () => document.removeEventListener('mousemove', onMove);
//   }, []);

//   const handleCursorHover = useCallback((hovered) => {
//     if (cursorRef.current) {
//       cursorRef.current.style.transform = hovered
//         ? `scale(1.8)`
//         : `scale(1)`;
//       cursorRef.current.style.borderColor = hovered
//         ? 'rgba(239, 68, 68, 0.8)'
//         : 'var(--cursor-color)';
//     }
//   }, []);

//   useEffect(() => {
//     const els = document.querySelectorAll('a, button, .btn, input, textarea, select, [data-cursor]');
//     const onOver = () => handleCursorHover(true);
//     const onOut = () => handleCursorHover(false);
//     els.forEach((el) => { el.addEventListener('mouseenter', onOver); el.addEventListener('mouseleave', onOut); });
//     return () => els.forEach((el) => { el.removeEventListener('mouseenter', onOver); el.removeEventListener('mouseleave', onOut); });
//   }, [handleCursorHover]);

//   return (
//     <div className="App">
//       <div className="custom-cursor" ref={cursorRef} />
//       <div className="custom-cursor-dot" ref={cursorDotRef} />
//       <div className="quantum-grid" />
//       <div className="noise-overlay" />
//       <ScrollToTop />
//       <Navbar />
//       <main>
//         <Routes>
//           <Route path="/" element={<MainPage />} />
//           <Route path="/helixone" element={<HelixHome />} />
//           <Route path="/helixone/databases" element={<HelixDatabases />} />
//           <Route path="/helixone/tools" element={<HelixTools />} />
//           <Route path="/helixone/tool/:id" element={<HelixToolDetails />} />
//           <Route path="/phiverse" element={<Phiverse />} />
//         </Routes>
//       </main>
//       <Footer />
//     </div>
//   );
// }

// export default App;



import React from "react";

const styles = `
  * {
    box-sizing: border-box;
  }

  html,
  body,
  #root {
    margin: 0;
    padding: 0;
    width: 100%;
    min-height: 100%;
  }

  body {
    background: #050505;
    color: #ffffff;
    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont,
      "Segoe UI", sans-serif;
  }

  .maintenance-page {
    position: relative;
    min-height: 100vh;
    width: 100%;
    overflow: hidden;

    display: flex;
    align-items: center;
    justify-content: center;

    background:
      radial-gradient(
        circle at 50% 45%,
        rgba(239, 68, 68, 0.10) 0%,
        rgba(239, 68, 68, 0.035) 25%,
        transparent 60%
      ),
      #050505;
  }

  /* Background grid */
  .maintenance-page::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;

    background-image:
      linear-gradient(
        rgba(255, 255, 255, 0.025) 1px,
        transparent 1px
      ),
      linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.025) 1px,
        transparent 1px
      );

    background-size: 70px 70px;

    mask-image: radial-gradient(
      ellipse at center,
      black 15%,
      transparent 75%
    );
  }

  /* Ambient glow */
  .maintenance-glow {
    position: absolute;

    width: 500px;
    height: 500px;

    border-radius: 50%;

    background: rgba(239, 68, 68, 0.06);

    filter: blur(120px);

    pointer-events: none;

    animation: ambientGlow 6s ease-in-out infinite;
  }

  @keyframes ambientGlow {
    0%,
    100% {
      transform: scale(1);
      opacity: 0.7;
    }

    50% {
      transform: scale(1.15);
      opacity: 1;
    }
  }

  /* Main content */
  .maintenance-content {
    position: relative;
    z-index: 2;

    width: min(720px, 90%);

    text-align: center;

    display: flex;
    flex-direction: column;
    align-items: center;
  }

  /* Gear */
  .maintenance-icon {
    width: 76px;
    height: 76px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-bottom: 30px;

    border: 1px solid rgba(239, 68, 68, 0.35);
    border-radius: 20px;

    background: rgba(239, 68, 68, 0.05);

    box-shadow:
      0 0 40px rgba(239, 68, 68, 0.08),
      inset 0 0 20px rgba(239, 68, 68, 0.03);
  }

  .maintenance-icon span {
    font-size: 31px;
    color: #ef4444;

    display: inline-block;

    animation: rotateGear 6s linear infinite;
  }

  @keyframes rotateGear {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  /* Small heading */
  .maintenance-label {
    margin-bottom: 18px;

    font-size: 12px;
    font-weight: 700;

    letter-spacing: 0.28em;

    color: #ef4444;
  }

  /* Main heading */
  .maintenance-content h1 {
    margin: 0;

    font-size: clamp(48px, 8vw, 88px);
    line-height: 0.95;

    font-weight: 800;
    letter-spacing: -0.055em;

    color: #ffffff;
  }

  .maintenance-content h1 span {
    display: block;

    color: transparent;

    background: linear-gradient(
      90deg,
      #ffffff 0%,
      #ef4444 50%,
      #ffffff 100%
    );

    background-size: 200% auto;

    -webkit-background-clip: text;
    background-clip: text;

    animation: gradientMove 5s ease infinite;
  }

  @keyframes gradientMove {
    0% {
      background-position: 0% center;
    }

    50% {
      background-position: 100% center;
    }

    100% {
      background-position: 0% center;
    }
  }

  /* Description */
  .maintenance-content p {
    max-width: 590px;

    margin: 30px auto 0;

    font-size: 16px;
    line-height: 1.8;

    color: rgba(255, 255, 255, 0.52);
  }

  /* Status pill */
  .maintenance-status {
    display: flex;
    align-items: center;
    gap: 10px;

    margin-top: 34px;

    padding: 10px 18px;

    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 999px;

    background: rgba(255, 255, 255, 0.025);

    font-size: 12px;
    font-weight: 600;

    letter-spacing: 0.08em;

    color: rgba(255, 255, 255, 0.55);
  }

  /* Status indicator */
  .status-dot {
    width: 7px;
    height: 7px;

    flex-shrink: 0;

    border-radius: 50%;

    background: #ef4444;

    box-shadow:
      0 0 0 4px rgba(239, 68, 68, 0.1),
      0 0 15px rgba(239, 68, 68, 0.6);

    animation: pulse 2s ease-in-out infinite;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
      transform: scale(1);
    }

    50% {
      opacity: 0.45;
      transform: scale(0.8);
    }
  }

  /* Divider */
  .maintenance-line {
    width: 100%;
    max-width: 420px;

    height: 1px;

    margin-top: 45px;

    background: linear-gradient(
      90deg,
      transparent,
      rgba(239, 68, 68, 0.4),
      transparent
    );
  }

  /* Footer */
  .maintenance-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    margin-top: 22px;

    font-size: 10px;
    font-weight: 700;

    letter-spacing: 0.18em;

    color: rgba(255, 255, 255, 0.25);
  }

  .maintenance-footer span:nth-child(2) {
    color: #ef4444;
  }

  /* Mobile */
  @media (max-width: 600px) {
    .maintenance-content {
      width: 88%;
    }

    .maintenance-icon {
      width: 62px;
      height: 62px;

      margin-bottom: 24px;
    }

    .maintenance-icon span {
      font-size: 25px;
    }

    .maintenance-label {
      font-size: 10px;
      letter-spacing: 0.2em;
    }

    .maintenance-content h1 {
      font-size: clamp(44px, 14vw, 65px);
    }

    .maintenance-content p {
      font-size: 14px;
      line-height: 1.7;

      margin-top: 24px;
    }

    .maintenance-status {
      margin-top: 28px;

      font-size: 10px;
    }

    .maintenance-footer {
      font-size: 8px;
      letter-spacing: 0.12em;
    }
  }
`;

function App() {
  return (
    <>
      <style>{styles}</style>

      <div className="maintenance-page">
        <div className="maintenance-glow"></div>

        <main className="maintenance-content">

          <div className="maintenance-icon">
            <span>⚙</span>
          </div>

          <div className="maintenance-label">
            SYSTEM MAINTENANCE
          </div>

          <h1>
            We’ll Be
            <span>Right Back.</span>
          </h1>

          <p>
            Our platform is currently undergoing scheduled maintenance
            and improvements. We’re working behind the scenes to make
            everything faster, smarter, and better.
          </p>

          <div className="maintenance-status">
            <span className="status-dot"></span>
            <span>Maintenance in progress</span>
          </div>

          <div className="maintenance-line"></div>

          {/* <div className="maintenance-footer">
            <span>PHIMIND</span>
            <span>•</span>
            <span>ADVANCING INTELLIGENCE</span>
          </div> */}

        </main>
      </div>
    </>
  );
}

export default App;